import { render, staticRenderFns } from "./Cards.vue?vue&type=template&id=775fe3f5&"
import script from "./Cards.vue?vue&type=script&lang=ts&"
export * from "./Cards.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports